import TagSelect from 'volta/components/tag-select';
import BvTag from 'volta/components/bv-tag';

import type { TOC } from '@ember/component/template-only';
import type { TEntityType } from 'volta/models/types/entity-types';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

type TagsEntityType = Extract<
  TEntityType,
  'skus' | 'bufferProfiles' | 'dafProfiles' | 'aduProfiles' | 'parts' | 'importHistos'
>;

export interface FiltersTagsFilterSignature
  extends IFilterArgs<{
    entityTypes: TagsEntityType[];
    warehouseIds?: string[];
    tag?: string;
    beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
  }> {}

const FiltersTagsFilterComponent: TOC<FiltersTagsFilterSignature> = <template>
  <TagSelect
    @values={{@values}}
    @onChange={{@onChange}}
    @beforeQuery={{@componentArgs.beforeQuery}}
    @warehouseIds={{@componentArgs.warehouseIds}}
    @entityTypes={{@componentArgs.entityTypes}}
    @selectedPath='tag'
    @propertyKey='tag'
    @multiple={{true}}
    @dataName={{@name}}
    as |item|
  >
    <BvTag @size='sm' @color='primary' @text={{item.tag}} />
  </TagSelect>
</template>;

export default FiltersTagsFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::TagsFilter': typeof FiltersTagsFilterComponent;
    'filters/tags-filter': typeof FiltersTagsFilterComponent;
  }
}
